/* eslint-disable */
// export const NAV_GROUPS = [
//   {
//     id: 'core',
//     title: 'Dashboard',
//     icon: DashboardIcon,
//     items: [
//       { route: ALL_ROUTES.dashboard.root, icon: ALL_ROUTES.dashboard.root.additional.icon },
//       { route: ALL_ROUTES.alert.list, icon: ALL_ROUTES.alert.list.additional.icon },
//     ]
//   },
//   {
//     id: 'patients',
//     title: 'Patient Care',
//     icon: PeopleIcon,
//     items: [
//       { route: ALL_ROUTES.patient.list, icon: ALL_ROUTES.patient.list.additional.icon },
//       { route: ALL_ROUTES.order.list, icon: ALL_ROUTES.order.list.additional.icon },
//       { route: ALL_ROUTES.assessment.list, icon: ALL_ROUTES.assessment.list.additional.icon },
//       { route: ALL_ROUTES.program.list, icon: ALL_ROUTES.program.list.additional.icon },
//     ]
//   },
//   {
//     id: 'resources',
//     title: 'Resources',
//     icon: ResourcesIcon,
//     items: [
//       { route: ALL_ROUTES.allergiEndResources.dashboard, icon: ALL_ROUTES.allergiEndResources.dashboard.additional.icon },
//       { route: ALL_ROUTES.resource.list, icon: ALL_ROUTES.resource.list.additional.icon },
//       { route: ALL_ROUTES.account.listDS, icon: ALL_ROUTES.account.listDS.additional.icon },
//     ]
//   }
// ];
//
// export const NAV_ADMIN_GROUP = {
//   id: 'admin',
//   title: 'Administration',
//   icon: AdminIcon,
//   items: [
//     { route: ALL_ROUTES.claim.list, icon: ALL_ROUTES.claim.list.additional.icon },
//     { route: ALL_ROUTES.reportable.list, icon: ALL_ROUTES.reportable.list.additional.icon },
//     { route: ALL_ROUTES.claimReport.list, icon: ALL_ROUTES.claimReport.list.additional.icon },
//     { route: ALL_ROUTES.botActivity.list, icon: ALL_ROUTES.botActivity.list.additional.icon },
//   ]
// };

export const STORAGE_KEY = 'qhs_navigation_expanded_groups';
